<template>
    <app-layout title="License">
        <template #header>
            <h2 class="text-3xl font-bold tracking-tight text-white">
                {{ __('Licenses - :title', {title: license.title}) }}
            </h2>
        </template>

        <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
            <aside class="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3 space-y-2">
              <nav class="space-y-4 p-4 bg-white rounded-lg shadow">
                <div class="space-y-1">
                  <span v-for="item in navigation" :key="item.view" @click="view = item.view"
                        :class="[item.view === view ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-100', 'group rounded-md px-3 py-2 flex items-center text-sm font-medium cursor-pointer']"
                        :aria-current="item.view === view ? 'page' : undefined">
                      <component :is="item.icon"
                                 :class="[item.view === view ? 'text-green-700 group-hover:text-green-700' : 'text-gray-400 group-hover:text-gray-500', 'flex-shrink-0 -ml-1 mr-3 h-6 w-6']"
                                 aria-hidden="true"/>
                      <span class="truncate">
                          {{ item.name }}
                      </span>
                  </span>
                </div>

              </nav>

              <div class="flex space-x-4 items-center">
                <a target="_blank" class="w-full" href="https://help.livck.com">
                  <primary-button class="w-full">{{ __('Documentation') }}</primary-button>
                </a>
                <a target="_blank" class="w-full" href="mailto:support@livck.com">
                  <secondary-button class="w-full" :modern="true">{{ __('Support') }}</secondary-button>
                </a>
              </div>

            </aside>

            <div class="space-y-4 sm:px-6 lg:px-0 lg:col-span-9">

              <license-details v-if="view === 'details'" :license="license"/>

              <subscription v-if="view === 'subscription'" :license="license"/>

              <allowlist v-if="view === 'allowlist'" :license="license"/>

            </div>
          </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import {KeyIcon, ShieldCheckIcon, InformationCircleIcon, UsersIcon} from "@heroicons/vue/outline";
import LicenseDetails from "@/Pages/License/Partials/Details";
import Allowlist from "@/Pages/License/Partials/Allowlist";
import Subscription from "@/Pages/License/Partials/Subscription";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import PrimaryButton from "@/Jetstream/PrimaryButton";
export default {
    name: "Show",
    components: {PrimaryButton, SecondaryButton, Subscription, Allowlist, LicenseDetails, AppLayout},
    props: ['license'],
    data() {
        return {
            view: 'details',
            navigation: [
                { name: this.__('Details'), view: 'details', icon: InformationCircleIcon },
                { name: this.__('Allowlist'), view: 'allowlist', icon: KeyIcon },
                { name: this.__('Subscription'), view: 'subscription', icon: ShieldCheckIcon },
            ]
        }
    }
}
</script>
